import React, { FC } from 'react';
import { Table } from 'antd';
import { WarningCircle } from 'common/svg';
import { getImproveQscStoreCardFindingsConfig, IImproveQscStoreCard } from 'entities/ImproveQsc/ImproveQsc.models';
import { ImproveQscSummary } from 'entities/ImproveQsc/components/ImproveQscSummary';

interface IComponentProps {
  storeCard: IImproveQscStoreCard;
}

export const ImproveQscStoreCard: FC<IComponentProps> = ({ storeCard }) => {
  const { storeCode, findings } = storeCard;

  return (
    <div className="iqsc-store-card">
      <div className="iqsc-store-card__header">
        <span className="ff-medium fs-xs color-whiteDark">{storeCode}</span>
      </div>

      <div>
        <div className="iqsc-store-card__summary">
          <ImproveQscSummary score={storeCard.score} />
        </div>

        <div className="iqsc-store-card__findings">
          <div className="mb-2 flex flex-align-center flex-justify-between">
            <span className="ff-medium fs-xxs">QSC Findings</span>
            <WarningCircle className="icon-gray" />
          </div>

          <Table
            className="iqsc-findings__table"
            pagination={false}
            // TODO update after updating IImproveQscStoreCard findings
            // eslint-disable-next-line
            dataSource={findings.map((i, index) => ({ key: index + 1, finding: i }))}
            columns={getImproveQscStoreCardFindingsConfig()}
            scroll={{ y: 233 }}
          />
        </div>
      </div>
    </div>
  );
};
